const SET_ERROR = (state, errors) => {
  state.errors = errors;
};

const SET_LOADING_HISTORY = (state, isLoading) => {
  state.isLoadingHistory = isLoading;
};

const SET_LOADING = (state, isLoading) => {
  state.isLoading = isLoading;
};

const SET_EXAM_LIST = (state, data) => {
  state.examList = data.data;
};

const SET_EXAM_COMBO = (state, data) => {
  state.examCombo = data.data;
};


const SET_EXAM_CATEGORY = (state, data) => {
  const exams = data.data;
  if (exams.length) {
    const category = exams[0];
    state.examCategory = {
      id: category.category.id,
      name: category.category.name,
      description: category.category.description,
      slug: category.category.slug,
      exams: data.data
    };

  state.pagination = {
    currentPage: data.meta.current_page,
    totalPages: data.meta.last_page,
    totalExams: data.meta.total
  }

    // current_page: 1
    // from: 1
    // last_page: 3
    // path: "http://api-hsk.staging.dbox.dev/api/exam/list"
    // per_page: 10
    // to: 10
    // total: 22
  }
};

const SET_EXAM_HISTORY = (state, data) => {
  state.examHistory = data.data;
}

const SET_EXAM_RESPONSE = (state, data) => {
  let response = JSON.parse(data.data.content)
  let result = JSON.parse(data.data.scores_part)

  for (var skillId in result) {
    if ('questions' in result[skillId]) {
      result[skillId].questions.forEach(res => {
        const resIndex = response.findIndex(item => {
          return item.question_id == res.question_id
        })

        if (resIndex > -1) {
          response[resIndex].score = res.score
        }
      })
    }
  }

  state.examResponse = {
    id: data.data.id,
    exam: data.data.exam,
    user: data.data.user,
    response: response,
    result: result,
    point: data.data.scores
  };
}

const SET_EXAM = (state, data) => {
  state.exam = data.data;
  state.examData = [];
  state.examIndex = [];
  let examAudio = [];
  let countQuestion = 0;

  data.data.questions.skills.forEach(skill => {
    let temp = {
      name: skill.name,
      isListening: skill.is_listening,
      questions: []
    };
    let tempIndex = {
      name: skill.name,
      total_time: skill.time,
      questions: []
    }

    skill.questions.forEach(question => {
      // For group questions
      // if (question.type == 103 || question.type == 104 || question.type == 155) {
      if (question.type_enum == 'group') {
        if (question.attachment_audio != '0') {
          examAudio.push(question.attachment_audio)
        }
        let childTemp = {
          question: question,
          children: []
        }
        question.children.forEach( childQuestion => {
          if (childQuestion.attachment_audio != '0') {
            examAudio.push(childQuestion.attachment_audio)
          }
          countQuestion++;
          childTemp.children.push({
            number: countQuestion,
            question: childQuestion
          });
          tempIndex.questions.push({
            number: countQuestion,
            question_id: childQuestion.id
          });
        });

        temp.questions.push(childTemp);
      } else {
        if (question.attachment_audio != '0') {
          examAudio.push(question.attachment_audio)
        }
        countQuestion++;
        temp.questions.push({
          number: countQuestion,
          question: question
        });
        tempIndex.questions.push({
          number: countQuestion,
          question_id: question.id
        });
      }
    });

    examAudio.push();

    state.examData.push(temp);
    state.examIndex.push(tempIndex);
    state.examAudio = examAudio;
  });
};

const SET_EXAM_DETAIL = (state, data) => {
  // Set exam level
  let level = data.rank.level
  const levelQuestionGroup = {
    4: [36, 38, 40, 42, 44],
    // 5: [31, 33, 36, 39, 42, 44],
    // 6: [16, 21, 26, 31, 34, 37, 40, 44, 48]
  }
  // Set examDetail
  state.examDetail = {
    id: data.id,
    slug: data.slug,
    name: data.name,
    description: data.description,
    content: data.content,
    time: data.time,
    rank: data.rank,
    is_room: data.is_room
  }
  // Init value
  state.examIndexList = []
  state.examDataList = []
  state.examAudioList = []
  let questionCount = 0

  data.skills.forEach(skill => {
    let tempIndexSkill = {
      id: skill.id,
      name: skill.name,
      time: skill.time,
      isListening: skill.is_listening,
      questions: []
    }
    let tempDataSkill = {
      id: skill.id,
      name: skill.name,
      time: skill.time,
      isListening: skill.is_listening,
      parts: []
    }

    skill.parts.forEach(part => {
      // Add part's description
      let tempPartQuestion = {
        id: part.id,
        name: part.name,
        description: part.description,
        questions: []
      }
      // Add part's audio
      if (part.attachment_audio != '0' && part.attachment_audio != null) {
        state.examAudioList.push({
          id: part.id,
          type: 'part',
          path: part.attachment_audio
        })
      }
      part.questions.forEach(question => {
        if (question.type_enum === 'single') {
        // Single question
          questionCount++
          // Add index list
          tempIndexSkill.questions.push({
            id: question.id,
            number: questionCount,
            type: question.type,
            typeEnum: question.type_enum,
            answers: question.answers
          })
          // Add data list
          tempPartQuestion.questions.push({
            id: question.id,
            number: questionCount,
            type: question.type,
            typeEnum: question.type_enum,
            audio: question.attachment_audio,
            image: question.attachment_image,
            content: question.content,
            images: question.image_group,
            timeHidden: question.time_hidden,
            answers: question.answers,
            explain: question.explain ? question.explain : "Đang bổ sung giải thích cho câu trả lời."
          })
          // Add question's audio
          if (question.attachment_audio != '0' && question.attachment_audio != null) {
            // Add number
            state.examAudioList.push({
              type: 'number',
              path: `/uploads/numbers/${questionCount}.mp3`
            })
            // Add question
            state.examAudioList.push({
              id: question.id,
              type: 'question',
              path: question.attachment_audio
            })
          }
        } else {
        // Group question
          let tempQuestion = {
            id: question.id,
            number: questionCount,
            type: question.type,
            typeEnum: question.type_enum,
            audio: question.attachment_audio,
            image: question.attachment_image,
            content: question.content,
            images: question.image_group,
            timeHidden: question.time_hidden,
            children: []
          }

          // Add question's intro audio
          if (level in levelQuestionGroup) {
            if (levelQuestionGroup[level].includes(questionCount + 1)) {
              // Add question
              state.examAudioList.push({
                id: question.id,
                type: 'question-intro',
                path: `/uploads/levels/hsk-${level}/${questionCount + 1}.mp3`
              })
            }
          }
          // Add question's audio
          if (question.attachment_audio != '0' && question.attachment_audio != null) {
            // Add question
            state.examAudioList.push({
              id: question.id,
              type: 'question-group',
              path: question.attachment_audio
            })
          }

          question.children.forEach(childQuestion => {
            questionCount++
            // Add index list
            tempIndexSkill.questions.push({
              id: childQuestion.id,
              number: questionCount,
              type: childQuestion.type,
              typeEnum: childQuestion.type_enum,
              answers: childQuestion.answers
            })
            // Add data list
            tempQuestion.children.push({
              id: childQuestion.id,
              number: questionCount,
              type: childQuestion.type,
              typeEnum: childQuestion.type_enum,
              audio: childQuestion.attachment_audio,
              image: childQuestion.attachment_image,
              content: childQuestion.content,
              images: childQuestion.image_group,
              timeHidden: childQuestion.time_hidden,
              answers: childQuestion.answers,
              explain: childQuestion.explain ? childQuestion.explain : "Đang bổ sung giải thích cho câu trả lời."
            })
            // Add question's audio
            if (childQuestion.attachment_audio != '0' && childQuestion.attachment_audio != null) {
              // Add number
              state.examAudioList.push({
                type: 'number',
                path: `/uploads/numbers/${questionCount}.mp3`
              })
              // Add question
              state.examAudioList.push({
                id: childQuestion.id,
                type: 'question',
                path: childQuestion.attachment_audio
              })
            }
            // Add children audio
            childQuestion.answers.forEach(answer => {
              if (answer.attachment_audio != '0' && answer.attachment_audio != null) {
                // Add number
                state.examAudioList.push({
                  type: 'number',
                  path: `/uploads/numbers/${questionCount}.mp3`
                })
                // Add question
                state.examAudioList.push({
                  id: childQuestion.id,
                  type: 'question',
                  path: answer.attachment_audio
                })
              }
            })
          })
          tempPartQuestion.questions.push(tempQuestion)
        }
      })

      tempDataSkill.parts.push(tempPartQuestion)
    })

    state.examIndexList.push(tempIndexSkill)
    state.examDataList.push(tempDataSkill)
  });



  

  state.examAudioList.push({
    type: 'number',
    path: `/uploads/numbers/end.mp3`
  })
}

const SET_EXAM_DETAIL_INDEX = (state, data) => {
  // Init value
  state.examDetail = {
    id: data.id,
    slug: data.slug,
    name: data.name,
    description: data.description,
    rank: data.rank
  }
  state.examIndexList = []

  data.skills.forEach(skill => {
    let tempIndexSkill = {
      id: skill.id,
      name: skill.name,
      time: skill.time,
      amount: 0,
      questions: []
    }
    
    skill.parts.forEach(part => {
      part.questions.forEach(question => {
        if (question.type_enum === 'single') {
        // Single question
          tempIndexSkill.amount++
          // Add index list
          tempIndexSkill.questions.push({
            id: question.id,
            type: question.type,
            typeEnum: question.type_enum,
            audio: question.attachment_audio,
            image: question.attachment_image,
            content: question.content,
            images: question.images,
            timeHidden: question.time_hidden,
            answers: question.answers
          })
        } else {
        // Group question
          question.children.forEach(childQuestion => {
            tempIndexSkill.amount++
            // Add index list
            tempIndexSkill.questions.push({
              id: childQuestion.id,
              type: childQuestion.type,
              typeEnum: childQuestion.type_enum,
              audio: childQuestion.attachment_audio,
              image: childQuestion.attachment_image,
              content: childQuestion.content,
              images: childQuestion.images,
              timeHidden: childQuestion.time_hidden,
              answers: childQuestion.answers,
              explain: childQuestion.explain ? childQuestion.explain : "Đang bổ sung giải thích cho câu trả lời."
            })
          })
        }
      })
    })

    state.examIndexList.push(tempIndexSkill)
  })
}

const SET_EXAM_SKILL = (state, data) => {
  state.examState.skill = data;
};

const SET_EXAM_PART = (state, data) => {
  state.examState.part = data;
};

const SET_EXAM_QUESTION = (state, data) => {
  state.examState.question = data;
};

const SET_LOADING_SCORE = (state, data) => {
  state.isLoadingScore = data;
};

const SET_EXAM_SCORE = (state, data) => {
  state.examScore = data.data;
};

export default {
  SET_ERROR,
  SET_LOADING,
  SET_LOADING_HISTORY,
  SET_EXAM_CATEGORY,
  SET_EXAM_LIST,
  SET_EXAM_DETAIL,
  SET_EXAM_COMBO,
  SET_EXAM,
  SET_EXAM_RESPONSE,
  SET_EXAM_DETAIL_INDEX,
  SET_EXAM_HISTORY,
  SET_EXAM_SKILL,
  SET_EXAM_PART,
  SET_EXAM_QUESTION,
  SET_EXAM_SCORE,
  SET_LOADING_SCORE
};